import { FC } from 'react';
import clsx from 'clsx';

interface CheckboxInterface {
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  name?: string;
  onChange?: (checked: boolean) => void;
  className?: string;
}

const Checkbox: FC<CheckboxInterface> = ({
  label,
  disabled,
  checked = false,
  name,
  onChange,
  className,
}) => {
  const handleCheckboxChange = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <label
      className={clsx(
        'inline-flex items-center gap-2 cursor-pointer',
        className,
        {
          'cursor-not-allowed opacity-50': disabled,
        }
      )}
      htmlFor={name}
    >
      <div
        className={clsx(
          'w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0',
          checked ? 'bg-primary border-primary' : 'bg-white border-grey-300',
          disabled && '!border-grey-200',
          checked && disabled && '!bg-grey-200'
        )}
      >
        {checked && (
          <i className="ri-check-line text-white text-base font-bold" />
        )}
      </div>
      <input
        checked={checked}
        className="hidden"
        disabled={disabled}
        name={name}
        type="checkbox"
        onChange={() => handleCheckboxChange()}
      />
      {label && (
        <div
          className={clsx(
            'text-body3 text-navy-600',
            disabled ? 'text-grey-300' : 'text-navy-600'
          )}
        >
          {label}
        </div>
      )}
    </label>
  );
};

export default Checkbox;
